// extracted by mini-css-extract-plugin
export default {"display-center":"CustomerGrid_display-center__eFALK","mr-10":"CustomerGrid_mr-10__6o8Ax","action-btns-wrapper":"CustomerGrid_action-btns-wrapper__CTTnM"};